import { render, staticRenderFns } from "./ActiveOrderId.vue?vue&type=template&id=ed4449fa&scoped=true&"
import script from "./ActiveOrderId.vue?vue&type=script&lang=js&"
export * from "./ActiveOrderId.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrderId.vue?vue&type=style&index=0&id=ed4449fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4449fa",
  null
  
)

export default component.exports